export default {
  setAuctions(state, payload) {
    state.auctions = payload;
  },
  setAuction(state, payload) {
    state.auction = payload;
  },
  setAuctionLots(state, payload) {
    state.lots = payload;
  },
  setLot(state, payload) {
    state.lot = payload;
  },
  setPage(state, payload) {
    state.page = payload;
  },
  setPagination(state, payload) {
    state.pagination = payload;
  },
  setBids(state, payload) {
    state.bids = payload;
  },
  addBids(state, payload) {
    state.bids = [payload, ...state.bids];
  },
};
